var BASWebServices;
(function (BASWebServices) {
    'use strict';
    function dialogMessage($compile) {
        return {
            templateUrl: "",
            scope: "=",
            link: function (scope, tElement, tAttrs, uploadElemenetCtrl) {
                var divExtension = "";
                tElement.append(divExtension);
                $compile(tElement.contents())(scope);
            }
        };
    }
    BASWebServices.dialogMessage = dialogMessage;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=dialogMessage.js.map